export default async (manifestUrl: string) => {
  try {
    return (await fetch(manifestUrl)).json();
  } catch (err) {
    console.error(`failed to load json manifest from ${manifestUrl}`, err);
    throw err;
  }
};
